import * as Sentry from "@sentry/react-native";
import { observer } from "mobx-react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Spacer } from "~/components/Spacer";
import { BodyText } from "~/components/V2/Text/BodyText";
import { Toggle } from "~/components/V2/Toggle";
import { View } from "~/components/V2/View";
import { useErrorAlertV2 } from "~/components/V2/error-alert-v2";
import { EditPetModal } from "./EditPetModal";

export const CastratedToggleModal = observer(function CastratedToggleModal({
  onClose,
  isVisible,
  initialValue = false,
}: {
  onClose: () => void;
  isVisible: boolean;
  initialValue?: boolean | null;
}) {
  const errorAlert = useErrorAlertV2();
  const [isCastrated, setIsCastrated] = React.useState(initialValue);

  return (
    <>
      {isVisible && (
        <EditPetModal
          onSave={async () => {
            try {
              onClose();
            } catch (error) {
              console.log("Error while updating mobile phone", error);
              errorAlert(error);
              Sentry.captureException(error);
            }
          }}
          onClose={onClose}
          title={intl.formatMessage({
            id: "vBD/H0",
            defaultMessage: "Update castrated status",
            description:
              "Field for indicating whether a pet is castrated or not.",
          })}
        >
          <View colorWhite borderRadius8 padding24 flexDirectionRow>
            <BodyText>
              <FormattedMessage
                id="BqUf8Z"
                defaultMessage="Castrated:"
                description="Label for indicating that a pet is castrated."
              />
            </BodyText>
            <Spacer extraLarge />
            <BodyText weightBold>
              <FormattedMessage
                id="IS8Z03"
                defaultMessage="No"
                description="No text"
              />
            </BodyText>
            <Spacer small />

            {/* Toggle */}
            <Toggle value={isCastrated} onValueChange={setIsCastrated} />
            <Spacer small />
            <BodyText weightBold>
              <FormattedMessage
                id="ThaO7S"
                defaultMessage="Yes"
                description="Yes text"
              />
            </BodyText>
          </View>
        </EditPetModal>
      )}
    </>
  );
});
